import { TPagination } from '../../../../hooks/use-pagination'
import { PaginationContainer } from './styles'
interface IProps {
  pagination: TPagination
}

const Pagination = (props: IProps) => {
  const { pagination } = props

  return (
    <PaginationContainer>
      <button
        className="prev-page"
        disabled={pagination.active === 1}
        onClick={() => pagination.previous()}
      >
        {'<'}
      </button>
      {pagination.range.map((item, idx) => {
        if (item === 'dots')
          return (
            <span key={item + idx} className="dots">
              ...
            </span>
          )

        return (
          <button
            key={item}
            type="button"
            className="page-button"
            onClick={() => pagination.setPage(item)}
            data-active={pagination.active === item}
          >
            {item}
          </button>
        )
      })}
      <button
        className="next-page"
        onClick={() => pagination.next()}
        disabled={pagination.active === pagination.total}
      >
        {'>'}
      </button>
    </PaginationContainer>
  )
}

export default Pagination
